<template>
  <v-card :color="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-2'">
    <v-row class="no-gutters align-center">
      <v-col cols="12" sm="6" md="4" lg="2">
        <v-text-field v-model="search" @input="debounceSearch" prepend-icon="mdi-magnify" label="Search here ..."
          single-line solo hide-details>
        </v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="2">
        <v-select solo :items="allAccounts()" v-model="account" @input="accountFilter" append-icon="mdi-chevron-down"
          label="Account Types" class="custom-select" item-text="account_type_display" item-value="id"></v-select>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="2">
           <v-dialog ref="dialog" v-model="modal" :return-value.sync="date" width="290px" class="">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="selectedDatesText" placeholder="Date filter" prepend-icon="mdi-calendar"
              append-icon="mdi-chevron-down" readonly v-bind="attrs" v-on="on" solo
              class="custom-select"></v-text-field>
          </template>
          <v-date-picker v-model="selectedDates" class="custom-date-picker" scrollable range>
            <v-spacer></v-spacer>
            <v-btn :color="$vuetify.theme.dark ? '#ff567f' : '#ff567f'" text @click="cancelSelection">
              Cancel
            </v-btn>
            <v-btn :color="$vuetify.theme.dark ? '#fff' : '#131c29'" text @click="confirmSelection">
              OK
            </v-btn>
          </v-date-picker>
        </v-dialog>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="2" align="middle">
        <v-card :color="$vuetify.theme.dark ? 'transparent' : '#f2f7fb'" flat tile>
          <div class="mt-6 custom-checkbox-wrapper">
            <input v-model="testData" class="custom-checkbox-acc" type="checkbox" @change="fetchData" />
            <span class="ml-1 text--ash">Testing A/C</span>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="8" lg="4">
        <ul>
          <li>
            <span class="">Total Account:</span>
            <span>{{ pagination?.total }}</span>
          </li>

          <li>
            <span class="">Total Equity:</span>
            <span>{{ formattedAllNumber(totalEquity) }}</span>
          </li>
          <li>
            <span class="text--green">Total Balance:</span>
            <span>{{ formattedAllNumber(totalBalance) }}</span>
          </li>
          <!-- <li>
            <v-btn small outlined elevation="0" @click="downloadExcel">
              <v-icon>mdi-file-download-outline</v-icon>
            </v-btn>
          </li> -->
        </ul>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12">
        <v-card class="pa-0 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
          <v-sheet class="transactionTable depositTabTable registerUserTable"
            :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
            <v-data-table :headers="headers" :items="accounts" :server-items-length="pagination?.total || 10"
              :options.sync="options" :loading="isLoading" :items-per-page="options.itemsPerPage" :footer-props="{
                'items-per-page-options': [10, 25, 50, 100],
                'items-per-page-text': 'Rows per page:'
              }" @update:options="handleOptionsChange" disable-sort>
              <template v-slot:loading>
                <div class="d-flex align-center justify-center pa-4">
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  <span class="ml-2">Loading data...</span>
                </div>
              </template>
              <template v-slot:no-data>
                <div class="d-flex align-center justify-center pa-4">
                  <v-icon color="secondary">mdi-information</v-icon>
                  <span class="ml-2">No data found</span>
                </div>
              </template>
              <template v-slot:no-results>
                <div class="d-flex align-center justify-center pa-4">
                  <v-icon color="secondary">mdi-magnify</v-icon>
                  <span class="ml-2">No matching data found</span>
                </div>
              </template>
              <template v-slot:item.trading_account_no="{ item }">
                {{ item?.trading_account_no}} ({{ item?.tradingaccounttypes?.account_type_display }})
              </template>
              <template v-slot:item.created_at="{ item }">
                {{ formatMySQLDate(item?.created_at)}}
              </template>
              <template v-slot:item.email="{ item }">
                <v-tooltip top color="#000">
                  <template v-slot:activator="{ on }">
                    <v-btn plain title x-small v-on="on" @click="copyText(item)" style="text-transform: none">
                      {{ obfuscateAnyEmail(item?.email) }}
                      <v-icon x-small class="ml-1" :color="copiedStates[item.id] ? 'green' : ''">
                        {{
                          copiedStates[item.id]
                            ? "mdi mdi-check"
                            : "mdi-content-copy"
                        }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ item.email }}</span>
                </v-tooltip>
              </template>
              <template v-slot:item.accounts="{ item }">
                 <router-link class="text-capitalize text--ash"
                  :to="`/registered-user-details/${item?.client_account_id}`">
                  {{ item?.fname }} {{ item?.fname }} {{ "(" + item.client_account_id + ")" }}
                </router-link>
              </template>
              <template v-slot:item.leverage="{ item }">
                {{ 1 + ":" + item.leverage }}
              </template>
              <template v-slot:item.password="{ item }">
                {{
                  item.password.length > 10
                    ? item.password.substring(0, 10) + "..."
                    : item.password
                }}
              </template>
              <template v-slot:item.investor_password="{ item }">
                {{
                  item.investor_password.length > 10
                    ? item.investor_password.substring(0, 10) + "..."
                    : item.investor_password
                }}
              </template>
              <template v-slot:item.Balance="{ item }">
                {{ item.Balance.toFixed(2) || "N/A" }}
              </template>
              <template v-slot:item.admin_name="{ item }">
                {{ item?.admin_name || "Self" }}
              </template>
              <template v-slot:item.Equity="{ item }">
                {{ item.Equity.toFixed(2) || "N/A" }}
              </template>
              <template v-slot:item.status="{ item }">
                <span class="text--green">
                  {{ item.status === 1 ? "Active" : "Inactive" }}
                </span>
              </template>
            </v-data-table>
          </v-sheet>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
import {
  LIVEACCOUNTS__ACTIONS,
  ACCOUNTTYPES__ACTIONS,
} from "@/store/action-types";
import * as XLSX from "xlsx";
import { formatNumber } from "@/_helpers/formatNumber";
import { obfuscateEmail } from "@/_helpers/obfuscateEmail";
import { formatMySQLDate } from "@/_helpers/formateDate";

export default {
  data() {
    return {
      search: "",
      testData: false,
      searchTimeout: null,
      selectedDates: [],
      selectedDatesText: null,
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      modal: false,
      isCopied: false,
      copiedStates: {},
      account: null,
      date: null,
      headers: [
        { text: "Registered At", align: "start", value: "created_at" },
        { text: "Name", value: "accounts" },
        { text: "Acc No", value: "trading_account_no" },
        { text: "Email", value: "email" },
        { text: "Password", value: "password" },
        { text: "Investor Pass.", value: "investor_password" },
        { text: "Leverage", value: "leverage" },
        { text: "Equity", value: "Equity" },
        { text: "Balance", value: "Balance" },
        { text: "Created By", value: "admin_name" },
        { text: "Status", value: "status" },
      ],
    };
  },

  computed: {
    ...mapState("liveaccounts", [
      "accounts",
      "totalBalance",
      "totalEquity",
      "pagination",
      "isLoading",
    ]),
    ...mapState("accounttypes", ["accounttypes"]),
  },

  methods: {
    formatMySQLDate,
    ...mapActions("liveaccounts", [LIVEACCOUNTS__ACTIONS.LIVEACCOUNTS]),
    ...mapActions("accounttypes", [ACCOUNTTYPES__ACTIONS.ACCOUNTTYPES]),

    formattedAllNumber(num) {
      return formatNumber(num || 0);
    },

    obfuscateAnyEmail(email) {
      return obfuscateEmail(email)
    },

    copyText(item) {
      navigator.clipboard.writeText(item.email);
      this.$set(this.copiedStates, item.id, true);
      setTimeout(() => {
        this.$set(this.copiedStates, item.id, false);
      }, 1000);
    },

    allAccounts() {
      return [{ id: "All", account_type_display: "All" }, ...this.accounttypes];

    },

    downloadExcel() {
      const wb = XLSX.utils.book_new();
      const apiData = this.accounts;

      const modifiedData = apiData.map((item) => ({
        "USER ID": item.client_account_id,
        NAME: item.fname + " "  + item.lname,
        EMAIL: item.email,
        "REGISTERED AT": item.created_at,
        PASSWORD: item.password,
        "INVESTOR PASSWORD": item.investor_password,
        LEVERAGE: item.leverage,
        EQUITY: item.Equity || "N/A",
        BALANCE: item.Balance || "N/A",
      }));

      const ws = XLSX.utils.json_to_sheet(modifiedData);
      XLSX.utils.book_append_sheet(wb, ws, "live Accounts");
      const totalRow = modifiedData.length + 2;

      ws["!ref"] = XLSX.utils.encode_range({
        s: { c: 0, r: 0 },
        e: { c: 9, r: totalRow },
      });

      XLSX.writeFile(wb, "live_accounts.xlsx");
    },

     async fetchData() {
      const parameter = {
        page: this.options.page || 1,
        limit: this.options.itemsPerPage || 10,
        search: this.search,
        testData: this.testData,
        trading_account_type_id: this.account === "All" ? null : this.account,
      };

      if (this.selectedDates?.length === 2) {
        parameter.duration = `${this.selectedDates[0]}to${this.selectedDates[1]}`;
      }

      await this[LIVEACCOUNTS__ACTIONS.LIVEACCOUNTS](parameter);
    },

    async handleSearch(value) {
      await this.fetchData();
    },

    debounceSearch() {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.handleSearch();
      }, 500);
    },

    handleOptionsChange(options) {
      this.fetchData();
    },

    accountFilter() {
      this.options.page = 1;
      this.fetchData();
    },
     getCurrentDate() {
      return new Date().toISOString().split("T")[0];
    },

    cancelSelection() {
      this.modal = false;
      this.selectedDates = [];
      this.selectedDatesText = null
      this.fetchData();
    },

    confirmSelection() {
      if (this.selectedDates.length !== 2) {
        toast.error("Please select both start and end dates");
        return;
      }

      let [startDate, endDate] = this.selectedDates;
      if (new Date(startDate) > new Date(endDate)) {
        [startDate, endDate] = [endDate, startDate];
      }

      this.selectedDatesText = `${startDate} ~ ${endDate}`;
      this.modal = false;
      this.options.page = 1;
      this.fetchData();
    },
  },

  async created() {
    await this.fetchData()
    await this[ACCOUNTTYPES__ACTIONS.ACCOUNTTYPES]();
  },
};
</script>
